export function versionEtag(updatedAt: string | undefined): string | undefined {
  if (!updatedAt) return undefined;
  const normalized = updatedAt.endsWith("Z")
    ? updatedAt
    : updatedAt.endsWith("+00:00")
      ? `${updatedAt.slice(0, -6)}Z`
      : `${updatedAt}Z`;
  return `"${normalized}"`;
}

export function conditionalHeaders(
  updatedAt: string | undefined
): { "If-Match": string } | undefined {
  const value = versionEtag(updatedAt);
  return value ? { "If-Match": value } : undefined;
}
